import { render, staticRenderFns } from "./TableOfMembers.vue?vue&type=template&id=27ece59e&scoped=true&"
import script from "./TableOfMembers.vue?vue&type=script&lang=js&"
export * from "./TableOfMembers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27ece59e",
  null
  
)

export default component.exports